export default __webpack_public_path__ + "static/media/480_dummy2016-beauty02-de.98ab8fbd.png";